import { render, staticRenderFns } from "./msglist.vue?vue&type=template&id=7373af20&scoped=true&"
import script from "./msglist.vue?vue&type=script&lang=js&"
export * from "./msglist.vue?vue&type=script&lang=js&"
import style0 from "./msglist.vue?vue&type=style&index=0&id=7373af20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7373af20",
  null
  
)

export default component.exports